import styled from 'styled-components'
import {spacing} from '../../../../../theme/spacing'

export const Button = styled.button`
    border: none;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;

    color: ${(props) => props.theme.reports.narrowButton.default.textColor};
    background-color: ${(props) => props.theme.reports.narrowButton.default.backgroundColor};
    border: 1px solid;
    border-radius: 6px;
    padding: ${spacing(1)};
    width: 82px;
    height: 26px;
    &:hover {
        color: ${(props) => props.theme.reports.narrowButton.hover.textColor};
        background-color: ${(props) => props.theme.reports.narrowButton.hover.backgroundColor};
    }
`
